import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {ToolsService} from '../../../../services/tools.service';

@Component({
  selector: 'app-care-service-about-cpru',
  templateUrl: './care-service-about-cpru.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CareServiceAboutCpruComponent {
  public name = input<string>(null);
  public url = input<string[]>(null);
  public city = input<string>(null);
  public image = input<string>(null);
  public description = input<string>(null);
  private tools = inject(ToolsService);
  protected shortDesctiption = computed<string>(() => this.tools.shortenHtmlDescription(this.description(), 9999));
}
